import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { SharedModule } from '@shared';
import { MaterialModule } from '../material.module';
import { LandingPageComponent } from './landing-page.component';
import { LandingPageRoutingModule } from './landing-page-routing.module';
import { AnimatedDigitModule } from '@app/animated/animated-digit/animated-digit.module';
import { DynamicImageModule } from '@app/dynamic-image/dynamic-image.module';
import { RegisterFormComponent } from '@app/register-form/register-form.component';
import { WebsiteFragmentsModule } from '@app/website_fragments/website-fragments.module';
import { WebinarComponent } from '@app/website_fragments/products/webinar/webinar.component';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    SharedModule,
    MaterialModule,
    LandingPageRoutingModule,
    AnimatedDigitModule,
    DynamicImageModule,
    RegisterFormComponent,
    WebsiteFragmentsModule,
    WebinarComponent,
  ],
  declarations: [LandingPageComponent],
  exports: [LandingPageComponent],
})
export class LandingPageModule {}
